import LoadingState from '../../components/LoadingState';
import { useTranslation } from '../../i18n/i18n';

export default function WaitingContent() {
  const { t } = useTranslation();
  return (
    <LoadingState
      title={t('waitingForPresentation.title')}
      subtitle={t('waitingForPresentation.hint')}
    />
  );
}
